$(function() {
	$(".our-work-navigation-link:not(.active)").hover(
		( function() { 
			$(".our-work-navigation-link.active").addClass("hover");
		}),
		( function() {
			$(".our-work-navigation-link.active").removeClass("hover");
		})
	);
});